import React from "react";
import { Button } from "_c/button";
import PT from "prop-types";
import { useSelector } from "react-redux";
import { Selectors } from "@/store/saloonProfile/selectors";
import PlusIcon from "_c/icon/Plus";
import { SALOON_PROFILE_NS as ns } from "@/i18n/ns";
import MasterPickerModal from "_c/Modals/saloon-master-picker-modal";
import { useToggle } from "@/hooks/useToggle";
import BrowserOnly from "@/components/BrowserOnly";

const AddService = (props) => {
  const [isPickerOpen, toggleIsPickerOpen] = useToggle();
  const saloonId = useSelector(Selectors.getId);
  return (
    <>
      <div
        css={`
          display: flex;
          justify-content: center;
          margin-bottom: 15px;
        `}
      >
        <Button
          css={`
            padding-bottom: 14px;
          `}
          withIcon
          greenish
          onClick={toggleIsPickerOpen}
        >
          <PlusIcon color="white" />
          <span>{props.t(`${ns}:services.add_service`)}</span>
        </Button>
      </div>
      <BrowserOnly>
        <MasterPickerModal
          t={props.t}
          saloonId={saloonId}
          isOpen={isPickerOpen}
          onClose={toggleIsPickerOpen}
          onSelect={({ masterId }) =>
            props.onMasterSelect({ master: masterId })
          }
        />
      </BrowserOnly>
    </>
  );
};
AddService.propTypes = {
  onMasterSelect: PT.func.isRequired,
  t: PT.func.isRequired,
};
export default AddService;
